<pds-modal #modal [width]="720" title="Detalhes da falha de conciliação" (dismiss)="onDismiss()">
  @if (failure(); as f) {
  <div class="conciliation-failure">
    <div class="conciliation-failure__header">
      <div class="conciliation-failure__header__card">
        <h3 class="conciliation-failure__header__card__title">Nota fiscal</h3>
        <div class="conciliation-failure__header__card__content">{{ invoiceCode() || '—' }}</div>
      </div>
      <div class="conciliation-failure__header__card">
        <h3 class="conciliation-failure__header__card__title">Etapa</h3>
        <div class="conciliation-failure__header__card__content">{{ stepLabel(f.step) }}</div>
      </div>
    </div>

    @if (f.message) {
    <div class="conciliation-failure__disclaimer">
      <pds-alert type="warning">
        <div>{{ f.message }}</div>
      </pds-alert>
    </div>
    } @if (f.step === 'ITEMS' && f.perOrder?.length) {
    <div class="conciliation-failure__orders">
      @for (entry of f.perOrder; track entry.orderId || $index) {
      <div class="conciliation-failure__order">
        <div class="conciliation-failure__order__header">
          <div>
            <h4 class="conciliation-failure__order__header__title">Pedido Identificado</h4>
            @if (entry.orderId) {
            <a class="conciliation-failure__order__header__id" [routerLink]="['/compras/pedidos-de-compra', entry.orderId, 'produtos']" target="_blank">
              {{ commerceReference() || entry.orderId }}
            </a>
            } @else {
            <span class="conciliation-failure__order__header__id">{{ commerceReference() || '—' }}</span>
            }
          </div>
          @if (entry.reason) {
          <span class="conciliation-failure__order__header__reason">{{ reasonLabel(entry.reason) }}</span>
          }
        </div>

        @if (entry.items?.length) {
        <section class="conciliation-failure__section">
          <h5 class="conciliation-failure__section__title">Itens do pedido de compra</h5>
          <table class="conciliation-failure__table">
            <thead>
              <tr>
                <th>Código</th>
                <th>Catálogo</th>
                <th>Qtd</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              @for (item of entry.items; track $index) {
              <tr [class.--mismatch]="isMismatch(item.status)">
                <td>{{ item.orderProduct?.sellerCode || '—' }}</td>
                <td>{{ item.orderProduct?.catalogId || '—' }}</td>
                <td>{{ item.orderProduct?.qty ?? '—' }}</td>
                <td>{{ statusLabel(item.status) }}</td>
              </tr>
              }
            </tbody>
          </table>
        </section>
        } @if (entry.items?.length || entry.unmatchedInvoiceItems?.length) {
        <section class="conciliation-failure__section">
          <h5 class="conciliation-failure__section__title">Itens da nota fiscal</h5>
          <table class="conciliation-failure__table">
            <thead>
              <tr>
                <th>Seq</th>
                <th>Código</th>
                <th>Qtd</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              @for (item of entry.items; track 'matched-' + $index) { @if (item.matchedInvoiceItem) {
              <tr [class.--mismatch]="isMismatch(item.status)">
                <td>{{ item.matchedInvoiceItem.seq ?? '—' }}</td>
                <td>{{ item.matchedInvoiceItem.code || '—' }}</td>
                <td>{{ item.matchedInvoiceItem.qty ?? '—' }}</td>
                <td>{{ statusLabel(item.status) }}</td>
              </tr>
              } } @for (item of unmatchedInvoiceItemsFor(entry); track 'unmatched-' + $index) {
              <tr class="--mismatch">
                <td>{{ item.seq ?? '—' }}</td>
                <td>{{ item.code || '—' }}</td>
                <td>{{ item.qty ?? '—' }}</td>
                <td>Sem correspondência no pedido</td>
              </tr>
              }
            </tbody>
          </table>
        </section>
        }
      </div>
      }
    </div>
    }
  </div>
  }
</pds-modal>
